export default __webpack_public_path__ + "static/media/Dansn_A4_Brochure2.8aadc6b8.jpg";